/**
 * Grupo de funcionalidades padrão.
 */
const DEFAULT = "DEFAULT";

/**
 * Grupo de funcionalidades relacionadas à confiabilidade.
 */
const RELIABILITY = "RELIABILITY";

/**
 * Grupo de funcionalidades relacionadas à tabela de KPI.
 */
const KPI_TABLE = "KPI_TABLE";
/**
 * Grupo de funcionalidades relacionadas ao Hub.
 */
const HUB = "HUB";

/**
 * Grupo de funcionalidades relacionadas ao Drivetrain.
 */
const DRIVETRAIN = "DRIVETRAIN";

/**
 * Grupo de features.
 */
const FeatureGroup = {
	[DEFAULT]: {
	  TRENDS:               "TRENDS",
	  REPORTS:              "REPORTS",
	  AUDIO:                "AUDIO",
	  MAINTENANCE:          "MAINTENANCE",
	  OCCURRENCES:          "OCCURRENCES",
	  RAW_RECORDS:          "RAW_RECORDS",
	  OIL:                  "OIL",
	  KINEMATIC_PARAMETERS: "KINEMATIC_PARAMETERS",
	},
	[DRIVETRAIN]: {
	  HEALTH_INDICATOR: "HEALTH_INDICATOR",
	  GLOBAL_VALUES:    "GLOBAL_VALUES",
	  DIAGNOSTIC:       "DIAGNOSTIC",
	  SCADA_CONNECTED:  "SCADA_CONNECTED"
	},
	[HUB]: {
	  GLOBAL_VALUES:     "GLOBAL_VALUES",
	  BLADE_GAP:         "BLADE_GAP",
	  BEARING_VIBRATION: "BEARING_VIBRATION",
	  DRIVE_CURRENT:     "DRIVE_CURRENT",
	  HEALTH_INDICATOR:  "HEALTH_INDICATOR",
	},
	[KPI_TABLE]: {
	  PERFORMANCE_FACTOR: "PERFORMANCE_FACTOR",
	  CAPACITY_FACTOR:    "CAPACITY_FACTOR",
	  HEALTH_INDICATOR:   "HEALTH_INDICATOR",
	},
	[RELIABILITY]: {
	  DASHBOARD: "DASHBOARD",
	  CURVES:    "CURVES",
	},
};

export {
	FeatureGroup, DEFAULT, RELIABILITY, KPI_TABLE, HUB, DRIVETRAIN
};